import React from "react";
import ResetPasswordWidget from "../components/ResetPasswordWidget";
import AuthTwoColumnedPage from "../components/AuthTwoColumnedPage";

export default function ResetPasswordPage() {
  return (
    <AuthTwoColumnedPage
      title={
        "Education is a passport to step the world and a key to unlock doors."
      }
      caption={""}
      boxTitle={"Reset Password"}
      boxCaption={"Input new password twice"}
    >
      <ResetPasswordWidget />
    </AuthTwoColumnedPage>
  );
}
